import React from 'react';
import { styled } from '@compiled/react';
import { Box, Stack } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import MagicSearch from '@atlassian/jira-illustrations/src/ui/adg4/brand/spots/software/components/magic-search/index.tsx';
import { FullWidthText } from '../../full-width-text/index.tsx';

export const NoRecentResults = ({ message }: { message: string }) => (
	<FullWidthText>
		<Box>
			<Stack space="space.050">
				<ImageWrapper>
					<MagicSearch alt="" fill />
				</ImageWrapper>
				{message}
			</Stack>
		</Box>
	</FullWidthText>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ImageWrapper = styled.div({
	height: token('space.600'),
	position: 'relative',
});
